import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
      <div className="mb-8 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl">按题材找漫画</h2>
          <p className="mt-1 text-sm text-foreground-500">
            从校园、恋爱到奇幻与悬疑，快速进入你喜欢的双女主韩漫世界
          </p>
        </div>
        <Link
          to="/search"
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          查看全部漫画
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {categories.map((category, index) => (
          <Link
            key={category.slug}
            to={`/category/${category.slug}`}
            className={`group relative overflow-hidden rounded-lg border border-background-200 bg-background-50 ${
              index === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
            }`}
          >
            <div className={`relative w-full ${index === 0 ? 'h-56 md:h-64' : 'h-44'}`}>
              <img
                src={category.cover}
                alt={`${category.name}双女主韩漫分类`}
                title={`${category.name}双女主韩漫免费阅读`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/35 to-transparent"></div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-4">
              <div className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className={`${category.icon} text-base`}></i>
                </span>
                <h3 className="text-lg font-bold text-background-50">{category.name}</h3>
              </div>
              <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-background-200">
                {category.description}
              </p>
            </div>
          </Link>
        ))}
        <div className="flex flex-col justify-center gap-3 rounded-lg border border-dashed border-background-300 bg-background-100 p-5">
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
            <i className="ri-compass-3-line text-xl"></i>
          </span>
          <h3 className="text-lg font-bold text-foreground-950">不知道看什么？</h3>
          <p className="text-xs leading-relaxed text-foreground-500">
            用关键词搜索作品名或作者，或从热门榜单开始，发现属于你的下一部双女主韩漫。
          </p>
          <Link
            to="/search"
            className="mt-1 flex w-fit items-center gap-1 whitespace-nowrap rounded-md bg-secondary-500 px-4 py-2 text-xs font-semibold text-background-50 transition-colors hover:bg-secondary-600"
          >
            <i className="ri-search-line"></i>
            去搜索
          </Link>
        </div>
      </div>
    </section>
  );
}